import React from "react";
import { Row, Col, Alert, Layout, Icon } from "antd";
import get from "lodash/get";
import Footer from "../../components/Footer/Footer";
import classes from "./SamlLogin.css";
import { getTheme } from "../../reducers/theme/selectors";
import { samlLogin } from "../../reducers/user/actions";
import { connect } from "react-redux";
import isNotAuthenticated from "../../utils/isNotAuthenticated";

const { Content } = Layout;

class SamlLogin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,
    };
  }

  async componentDidMount() {
    const token = get(this.props, "match.params.token");

    try {
      await this.props.samlLogin({token});
    } catch (e) {
      this.setState({ isError: true, isLoading: false });
      console.log(e);
    }
  }

  render() {
    const { isLoading, isError } = this.state;

    return (
      <div className={classes.container}>
        <h2 style={{ margin: "0 0 20px" }}>
          <img
            alt="diamond-trial-logo"
            src={this.props.theme.logo_dark}
            style={{ objectFit: "contain", width: "160px", height: "auto" }}
          />
        </h2>

        {isLoading && <Icon type="loading" style={{ fontSize: "18px" }} />}
        {isError && <Alert type="error" message="Something went wrong" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  theme: getTheme(state),
});

const mapDispatchToProps = {
  samlLogin,
};

export default isNotAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(SamlLogin)
);



// WEBPACK FOOTER //
// ./src/containers/SamlLogin/SamlLogin.js